import * as AlertNotification from '@givebutter/primitives/alert-notification';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';
import { useCurrentUser } from 'customHooks/useCurrentUser';

const NonProfitVerificationCancelled = () => {
    const { legalEntity } = useCurrentAccount();
    const { verification_status_reason } = legalEntity || {};

    const { email: userEmail } = useCurrentUser();

    if (!verification_status_reason) {
        return (
            <AlertNotification.Root type="warning">
                <AlertNotification.Icon />
                <AlertNotification.Content>
                    <AlertNotification.Title>Timed out due to inactivity</AlertNotification.Title>
                    <AlertNotification.Description>
                        You can try again by entering your EIN below.
                    </AlertNotification.Description>
                </AlertNotification.Content>
            </AlertNotification.Root>
        );
    }

    return (
        <AlertNotification.Root type="error">
            <AlertNotification.Icon />
            <AlertNotification.Content>
                <AlertNotification.Title>Unable to verify your nonprofit</AlertNotification.Title>
                <AlertNotification.Description>
                    After further review, we cannot verify your nonprofit on Givebutter. Please
                    refer to the most recent email sent to {userEmail} from
                    {import.meta.env.VITE_DASHBOARD_SAFETY_TEAM_EMAIL}, or contact{' '}
                    <a href={`mailto:${import.meta.env.VITE_DASHBOARD_SAFETY_TEAM_EMAIL}`}>
                        {import.meta.env.VITE_DASHBOARD_SAFETY_TEAM_EMAIL}
                    </a>{' '}
                    with any questions.
                </AlertNotification.Description>
            </AlertNotification.Content>
        </AlertNotification.Root>
    );
};

export { NonProfitVerificationCancelled };
